import WineSupplier from "./WineSupplier"

export default class PurchasePrice {
	constructor() {
		this.id = null
		this.price = null
		this.wineSupplier = new WineSupplier()
	}
}